module.exports = __webpack_public_path__ + "static/img/14001031.c935ddec.png";